(function videoDisclaimer() {
	window.addEventListener('load', () => {
		const containerStack = document.querySelectorAll('[data-video-embed]');

		for (let i = 0; i < containerStack.length; i++) {
			const container = containerStack[i];
			const playerContainer = container.querySelectorAll(
				'[data-video-embed-player]',
			);
			const buttonEl = container.querySelectorAll('[data-video-embed-button]');

			if (buttonEl.length > 0) {
				buttonEl[0].addEventListener('click', () => {
					const templateEl = container.querySelectorAll(
						'[data-video-embed-hidden-container]',
					);
					const disclaimerContent = container.querySelectorAll(
						'[video-embed-disclaimer-content]',
					);
					const disclaimerOverlay = container.querySelectorAll(
						'[video-embed-disclaimer-overlay]',
					);

					for (let j = 0; j < disclaimerContent.length; j++) {
						disclaimerContent[j].classList.add(
							'video-embed-disclaimer--is-hidden',
						);
						setTimeout(removeElement.bind(null, disclaimerOverlay[j]), 250);
					}
					playerContainer[0].innerHTML = templateEl[0].innerHTML;
				});
			}
		}

		function removeElement(element) {
			element.remove();
		}
	});
})();
